module.exports = __webpack_public_path__ + "img/scratch_cards_front.6ccfd179.jpg";